var map = {
	"./press1.jpg": 1221,
	"./press10.png": 1222,
	"./press11.png": 1223,
	"./press12.png": 1224,
	"./press13.png": 1225,
	"./press14.png": 1226,
	"./press15.png": 1227,
	"./press16.jpg": 1228,
	"./press17.jpg": 1229,
	"./press18.png": 1230,
	"./press19.jpg": 1231,
	"./press2.png": 1232,
	"./press20.jpeg": 1233,
	"./press21.png": 1234,
	"./press22.png": 1235,
	"./press23.png": 1236,
	"./press24.png": 1237,
	"./press25.png": 1238,
	"./press26.png": 1239,
	"./press27.jpg": 1240,
	"./press28.jpg": 1241,
	"./press29.png": 1242,
	"./press3.png": 1243,
	"./press4.jpg": 1244,
	"./press5.jpg": 1245,
	"./press6.png": 1246,
	"./press7.png": 1247,
	"./press8.jpg": 1248,
	"./press9.png": 1249
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1220;